import { Container } from "react-bootstrap";
import Carousel from "react-bootstrap/Carousel";
import "./ExtCarousel.css";

function ExtCarousel() {
  return (
    <Container>
      <Carousel>
        <Carousel.Item>
          <img
            className="d-block w-100 carousel-image"
            src="/assets/images/exterior1.jpg"
            alt="First slide"
            style={{borderRadius: "25px",height:'auto'}} //here add height to change height of image
          />
          <Carousel.Caption>
            <h3>First Exterior</h3>
            <p>....</p>
          </Carousel.Caption>
        </Carousel.Item>
        <Carousel.Item>
          <img
            className="d-block w-100 carousel-image"
            src="/assets/images/exterior2.jpg"
            alt="Second slide"
            style={{borderRadius: "25px",height:'auto'}}
          />
          <Carousel.Caption>
            <h3>Second Resident</h3>
            <p>....</p>
          </Carousel.Caption>
        </Carousel.Item>
        <Carousel.Item>
          <img
            className="d-block w-100 carousel-image"
            src="/assets/images/exterior3.jpg"
            alt="Third slide"
            style={{borderRadius: "25px",height:'auto'}}
          />
          <Carousel.Caption>
            <h3>Third Resident</h3>
            <p>....</p>
          </Carousel.Caption>
        </Carousel.Item>
        <Carousel.Item>
          <img
            className="d-block w-100 carousel-image"
            src="/assets/images/exterior4.jpg"
            alt="Third slide"
            style={{borderRadius: "25px",height:'auto'}}
          />
          <Carousel.Caption>
            <h3>fourth Resident</h3>
            <p>....</p>
          </Carousel.Caption>
        </Carousel.Item>
      </Carousel>
    </Container>
  );
}

export default ExtCarousel;
